import React, { Component } from "react";
import moment from 'moment-timezone';

export default class RuleInstanceLastPingStatus extends Component {
    render() {
        return (
            <span style={{
                height: 6,
                width: 6,
                borderRadius: '50%',
                display: 'inline-block',
                backgroundColor: this._getColor(),
                alignSelf: 'center',
                marginLeft: 4
            }}></span>
        )
    }

    _getColor() {
        const date = moment(this.props.lastPingTimeUtc);
        if (!date.isValid()) return 'orange';

        const diff = moment().utc().diff(date, 'minutes');

        return diff <= 35 ? 'green' : 'orange';        
    }
}


// WEBPACK FOOTER //
// ./src/components/RuleInstanceLastPingStatus/RuleInstanceLastPingStatus.js